import {
  DURATION_UNIT_KEYS,
  SECONDS_PER_DAY,
  SECONDS_PER_HOUR,
  SECONDS_PER_MINUTE,
} from '../Consts/monitoring-duration.const';
import { DurationPart } from '../Interfaces/duration-part.interface';

function toWholeSeconds(seconds: number | null | undefined): number {
  return typeof seconds === 'number' && Number.isFinite(seconds)
    ? Math.max(0, Math.round(seconds))
    : 0;
}

export function formatDurationParts(seconds: number | null | undefined): DurationPart[] {
  const total = toWholeSeconds(seconds);
  const parts: DurationPart[] = [
    { value: Math.floor(total / SECONDS_PER_DAY), unitKey: DURATION_UNIT_KEYS.days },
    {
      value: Math.floor((total % SECONDS_PER_DAY) / SECONDS_PER_HOUR),
      unitKey: DURATION_UNIT_KEYS.hours,
    },
    {
      value: Math.floor((total % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE),
      unitKey: DURATION_UNIT_KEYS.minutes,
    },
    { value: total % SECONDS_PER_MINUTE, unitKey: DURATION_UNIT_KEYS.seconds },
  ];

  // The two largest units that actually carry a value, so 24h47m reads "1d 47min", not a bare "1d".
  const carried = parts.filter((part) => part.value > 0).slice(0, 2);

  return carried.length > 0 ? carried : [{ value: 0, unitKey: DURATION_UNIT_KEYS.seconds }];
}
